import { render, staticRenderFns } from "./KBInvoicesServices.vue?vue&type=template&id=4a640a0a&"
import script from "./KBInvoicesServices.vue?vue&type=script&lang=ts&"
export * from "./KBInvoicesServices.vue?vue&type=script&lang=ts&"
import style0 from "./KBInvoicesServices.vue?vue&type=style&index=0&id=4a640a0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports